export default {
  statScientistsTitle: "Scientists & Researchers",
  statScientistsDescription: "Dedicated professionals driving innovation in pharmaceutical research and development",
  statScientistsImage: "https://readdy.ai/api/search-image?query=Professional%20pharmaceutical%20scientists%20and%20researchers%20working%20in%20modern%20laboratory&width=400&height=300",
  statProductsTitle: "Pharmaceutical Products",
  statProductsDescription: "Comprehensive portfolio of high-quality pharmaceutical products and APIs",
  statProductsImage: "https://readdy.ai/api/search-image?query=Comprehensive%20portfolio%20of%20high-quality%20pharmaceutical%20products&width=400&height=300",
  statMarketsTitle: "Global Markets",
  statMarketsDescription: "Serving healthcare needs across diverse international markets with regulatory excellence",
  statMarketsImage: "https://readdy.ai/api/search-image?query=Global%20pharmaceutical%20markets%20and%20international%20healthcare%20distribution&width=400&height=300",
};

